var _style, _path, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,31H7c-1.1,0-2-0.9-2-2V3c0-1.1,0.9-2,2-2h18c1.1,0,2,0.9,2,2v26C27,30.1,26.1,31,25,31z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    className: "st0",
    width: 14,
    height: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 14,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 14,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10,
    cy: 14,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 20,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 20,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10,
    cy: 20,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 26,
    r: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 26,
    r: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10,
    cy: 26,
    r: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalculator);
export default __webpack_public_path__ + "static/media/ico-calculator.8952c267.svg";
export { ForwardRef as ReactComponent };